var React = require('react');

function KudaTransferInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"18.5","cy":"18.5","r":"18.5","fill":"#EFF1FF","key":0}),React.createElement("path",{"d":"M21.9889 16.128L15.3663 21.2186L8.88867 18.5907L26.228 11.8887L19.526 29.228L16.8981 22.7502L21.9889 16.128Z","fill":"#40196D","key":1})]);
}

KudaTransferInline.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = KudaTransferInline;

KudaTransferInline.default = KudaTransferInline;
